import Request from './request';
import store from '@/store.js'
import snackbar from '@/plugins/snackbar'
import i18n from '@/i18n'

async function fetch(data) {
    return Request('get', "api/examines", data);
}

async function fetchOne(id, data) {
    return Request('get', "api/examines/view-by-group-material?id=" + id, data);
}

async function examine(data) {
    return Request('patch', "api/examines/examine-by-material", data);
}

async function abnormalDetail(id, data) {
    return Request('get', "api/examines/view_by_abnormal?id=" + id, data);
}

async function abnormalEdit(action,data) {
    if(action && action=='complete'){
        return Request('patch', "api/examines/abnormal-complete", data);
    } else if (action && action=='edit') {
        return Request('patch', "api/examines/abnormal-edit", data);
    }
}

async function batchExamine(data) { //批量验收
    return Request('get', "api/examines/batch-examine", data, false, false, true)
}

async function batchDetailExport(data) { //批量导出
  store.dispatch('fullscreenLoading')
  const response = await Request('get', 'api/examines/batch-detail-export', data)
  if (response.data && response.data.status.isOK()) {
    snackbar.info(i18n.t('Export.recordedHint'))
  }
  store.dispatch('fullscreenLoadingStop')
  return response
}

async function detailExport(id) { //导出
    store.dispatch('fullscreenLoading')
    const response = await Request('get', 'api/examines/detail-export/'+ id)
    if (response.data && response.data.status.isOK()) {
      snackbar.info(i18n.t('Export.recordedHint'))
    }
    store.dispatch('fullscreenLoadingStop')
    return response
  }

async function fetchRelations(id) {
    // 获取验收单相关单据
    return Request('get', 'api/examines/' + id + '/relations')
}

async function examineImgUpdate(data) {
    // 更新验收图片
    return Request('post', 'api/examines/update', data)
}

export default {
    fetch,
    fetchOne,
    examine,
    abnormalDetail,
    abnormalEdit,
    batchExamine,
    batchDetailExport,
    detailExport,
    fetchRelations,
    examineImgUpdate,
};